/**
 * 기능 플래그 (main 배포 시 false 유지 권장)
 * 캐릭터·코스메틱(학급 상점 연동, 옷장, 학생 홈 위젯 등) 공개 시 true로 변경
 */
export const FEATURE_CHARACTER_COSMETIC = true;

/** 연수 로비에서 MARU 내부 경로(/...) 링크·레거시 TSX 페이지 연결 비활성화 */
export const FEATURE_TRAINING_INTERNAL_LINKS = false;

/** 로비 진입 시 레거시 연수 자동 목록 동기화 비활성화 */
export const FEATURE_TRAINING_LEGACY_AUTO_SYNC = false;
